import { Col, Container, Row, Button, Card, CardBody, CardHeader } from "reactstrap";
import { Link } from 'react-scroll';
import ReactPlayer from 'react-player';
import logoSoal from '../../../assets/images/game/w2_assets/Questionbar.png'
import Pilihan1 from '../../../assets/images/game/w2_soal/no-5/FOTO-HOAKS-PFIZER-1.png'

import AnswerTrue from '../../../assets/images/game/w2_soal/no-5/SOAL NO 5. TUTORIAL KEYWORDS.mp4'
import { useContext, useState } from "react";
import { Context } from "../../../contexts/reducer/store";
import CheckAnswer from "../CheckAnswer";
import hiasan17 from '../../../assets/images/game/w2_assets/asset-meteor-biru.png'
import hiasan18 from '../../../assets/images/game/w2_assets/Asset-81.png'
import hiasan19 from '../../../assets/images/game/w2_assets/Asset-80.png'
import hiasan20 from '../../../assets/images/game/w2_assets/AdkBQM-full.png'
import Left from '../../../assets/images/game/w2_assets/question-title-left.png';
import Right from '../../../assets/images/game/w2_assets/question-title-right.png';

import Video from '../../../assets/video/no-5.mp4';

const Soal5 = () => {

    let [isOpen, setIsOpen] = useState(false)
    let [isTrue, setIsTrue] = useState(false)

    const [state, dispatch] = useContext(Context);
    const [disabled, setDisabled] = useState(false);

    function toggleModal ( type ) {
        setIsOpen(!isOpen);
        setIsTrue(type);
        setDisabled(true)
    }

    function SET_MARK ( value = Number ) {
        const init = {...state};
        let __mark = init.mark
        dispatch({type: 'SET_MARK', payload: __mark + value});
    }

    const Answer = () => {
        return (
            <>
                {
                    isTrue ?
                    (
                        <>
                            <div>
                                <div className="text-center py-3">
                                    <p>
                                        Melalui kata kunci “<b>Pfizer Vaccine Ingredient Heart Problems</b>” kamu dapat <br /> menemukan artikel yang memiliki kemiripan dengan isi klaim.
                                    </p>
                                </div>
                                <div className="text-center py-3">
                                    <small>
                                        Yuk, tonton video tutorial cek fakta menggunakan <br />teknik penentuan keywords/ kata kunci:
                                    </small>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div>
                                <div className="text-center">
                                    <p>
                                        Kata kunci yang kamu pilih tidak dapat langsung menghadirkan inti dari pencarian klaim yang ingin kamu dapatkan.
                                    </p>
                                </div>
                                <div className="text-center py-4">
                                    <small>
                                        Yuk, tonton video tutorial cek fakta menggunakan <br />teknik penentuan keywords/ kata kunci:
                                    </small>
                                </div>
                            </div>
                        </>
                    )
                }
                <ReactPlayer
                    className='react-player'
                    url={Video}
                    width='100%'
                    height='60vh'
                    playing={true}
                    loop={true}
                    controls={true}
                />
                <div className={`bg-light-green text-center py-1 ${isTrue ? 'd-none' : 'd-block'} my-3`}>
                    Jawaban yang benar pada soal adalah <br /><b>Pfizer Vaccine Ingredient Heart Problems.</b>
                </div>
            </>
        )
    }

    return (
        <>
            <Container className="position-relative front">
                <CheckAnswer Type={isTrue} isOpen={isOpen} setIsOpen={setIsOpen}>
                    <Answer />
                </CheckAnswer>
                <Row>
                    <Col md="12" className="text-center game-px">
                        <Row className="mb-5">
                            <Col>
                                <p className="super-title-soal5 montserrat text-white">
                                    Pada bagian game ini, kamu diminta melakukan penelusuran<br />
                                    cek fakta sederhana melalui sebuah klaim hoaks.
                                </p>
                            </Col>
                        </Row>
                        <Row className="mb-5">
                            <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                <img src={Left} alt="" />
                            </Col>
                            <Col lg="10" md="10" sm="10" xs="10" className="my-auto">
                                <Card className="card-title-quiz">
                                    <CardBody>
                                        <h2 className="judul-game-4 montserrat">
                                            KATA KUNCI ATAU <b>KEYWORDS</b> YANG BISA<br /> DIGUNAKAN <b>UNTUK MENELUSURI KLAIM DI ATAS<br /> MELALUI</b> MESIN PENCARIAN <b>GOOGLE</b> ADALAH...
                                        </h2>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                <img src={Right} alt="" />
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <Card className="card-game">
                                    <CardBody>
                                        <Row>
                                            <Col md="6" className="">
                                                <span className="judul-pilihan-soal-2">KLAIM HOAKS</span>
                                                <div className="p-4">
                                                    <img src={Pilihan1} alt="Klaim Hoaks" className="w-100" />
                                                </div>
                                            </Col>
                                            <Col md="6">
                                                <span className="judul-pilihan-soal-2">PENJELASAN KLAIM HOAKS</span>
                                                <div className="pt-4">
                                                    <p className="desc-soal6 montserrat text-start">
                                                        Menyebutkan Vaksin Pfizer mengubah komposisi pada vaksin Covid-19 untuk anak-anak buatannya dan dapat meningkatkan risiko radang jantung<br />
                                                        <br />
                                                        Narasi Terjemahan Klaim: <br />
                                                        <br />
                                                        “ Pfizer telah menambahkan Tromethamine,<br />
                                                        penurun asam darah yang digunakan untuk <br />
                                                        mengobati korban serangan jantung,<br />
                                                        ke dalam formulasi jab untuk anak-anak <br />
                                                        <br />
                                                        <br />
                                                        (halaman 14<br />
                                                        dari dokumen pengarahan FDA). ”
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        
                        {
                            disabled === false
                            ?   <Row className="pt-3">
                                    <Col md="12" className="mx-auto text-center p-0 pt-3">
                                        <Link to="q6" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(true), SET_MARK(1))}>PFIZER VACCINE INGREDIENT HEART PROBLEMS</Link>
                                    </Col>
                                    <Col md="12" className="mx-auto text-center p-0 pt-3">
                                        <Link to="q6" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>SINOVAC VACCINE INGREDIENT PROBLEMS</Link>
                                    </Col>
                                </Row>
                            :   <Row className="pt-3">
                                    <Col md="12" className="mx-auto text-center p-0 pt-3">
                                        <button className="btn btn-jawaban montserrat" disabled>PFIZER VACCINE INGREDIENT HEART PROBLEMS</button>
                                    </Col>
                                    <Col md="12" className="mx-auto text-center p-0 pt-3">
                                        <button className="btn btn-jawaban montserrat" disabled>SINOVAC VACCINE INGREDIENT PROBLEMS</button>
                                    </Col>
                                </Row>
                        }
                    </Col>
                </Row>
            </Container>
            <div className="position-relative img-asset">
                <img src={hiasan17} className="asset-17" />
                <img src={hiasan18} className="asset-18" />
                <img src={hiasan19} className="asset-19" />
                <img src={hiasan20} className="asset-20" />
            </div>
        </>
    )
}

export default Soal5